import React from 'react';
import { Button } from './ui/button';

export default function GoogleLoginButton({ label = 'Continuar con Google', testId = 'google-login-btn' }) {
    const handleGoogleLogin = () => {
        const callbackUrl = `${window.location.origin}/auth/callback`;
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(callbackUrl)}`;
    };

    return (
        <Button
            type="button"
            variant="outline"
            onClick={handleGoogleLogin}
            className="w-full gap-3 border-slate-300 bg-white text-slate-800 hover:bg-slate-50"
            data-testid={testId}
        >
            <svg className="h-4 w-4" viewBox="0 0 48 48" aria-hidden="true">
                <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.972 32.91 29.418 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.954 4 4 12.954 4 24s8.954 20 20 20c11.045 0 20-8.954 20-20 0-1.341-.138-2.65-.389-3.917z"/>
                <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
                <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.197l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.398 0-9.961-3.069-11.303-7.5l-6.51 5.02C9.625 39.612 16.27 44 24 44z"/>
                <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.094 5.565l6.19 5.238C39.962 36.62 44 31 44 24c0-1.341-.138-2.65-.389-3.917z"/>
            </svg>
            <span className="text-sm font-medium">{label}</span>
        </Button>
    );
}
